var map = {
	"./ar/Strings.json": [
		"./langs/cowork/ar/Strings.json",
		"langs_cowork_ar_Strings_json"
	],
	"./en/Strings.json": [
		"./langs/cowork/en/Strings.json",
		"langs_cowork_en_Strings_json"
	],
	"./ru/Strings.json": [
		"./langs/cowork/ru/Strings.json",
		"langs_cowork_ru_Strings_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./langs/cowork lazy recursive ^\\.\\/.*\\/Strings\\.json$";
module.exports = webpackAsyncContext;